// extracted by mini-css-extract-plugin
export var errorIcon = "_or-1";
export var nameLogo = "_or-0";